import { render, staticRenderFns } from "./EditSwap.vue?vue&type=template&id=3e831c8a&"
import script from "./EditSwap.vue?vue&type=script&lang=js&"
export * from "./EditSwap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports